export default class EnumDataSource {
  data: { [code: string | number]: string } = {};
  order: { [code: string | number]: number } = {};

  constructor(
    data: { [code: string | number]: string } = {},
    order: { [code: string | number]: number } = {}
  ) {
    this.data = data;
    this.order = order || {};
  }

  addOption(code: string | number, value: string) {
    this.data[code] = value;
  }

  getFromCode(code?: string | number | null) {
    if (code === null || code === undefined) {
      return "";
    }
    return this.data[code] || "";
  }

  private getSortedKeys() {
    return Object.keys(this.data).sort((aKey, bKey) => {
      // Convert keys to numbers if they are numeric strings
      const a = isNaN(Number(aKey)) ? aKey : Number(aKey);
      const b = isNaN(Number(bKey)) ? bKey : Number(bKey);

      const aOrder = this.order[a] ?? Number.MAX_SAFE_INTEGER;
      const bOrder = this.order[b] ?? Number.MAX_SAFE_INTEGER;
      return aOrder - bOrder;
    });
  }

  getOptions(excludeCodes: (string | number)[] = []) {
    return this.getSortedKeys()
      .filter(
        (code: string) =>
          excludeCodes.find((excludeCode) => String(excludeCode) === code) ===
          undefined
      )
      .map((code: string) => ({
        value: code,
        label: this.data[code],
      }));
  }

  getOptionsSortedByLabel(excludeCodes: string[] = []) {
    return this.getCodes()
      .filter((code: string) => !excludeCodes.includes(code))
      .map((code: string) => ({
        value: code,
        label: this.data[code],
      }))
      .sort((a, b) => a.label.localeCompare(b.label));
  }

  getCodes(excludeCodes: (string | number)[] = []) {
    return this.getSortedKeys().filter(
      (code: string) =>
        excludeCodes.find((excludeCode) => String(excludeCode) === code) ===
        undefined
    );
  }

  getValues() {
    return this.getSortedKeys().map((key) => this.data[key]);
  }
}
